// extracted by mini-css-extract-plugin
export var copyableField = "_ks-4";
export var customerBadge = "_ks-0";
export var customerInfoTitle = "_ks-2";
export var details = "_ks-1";
export var dropdownContainer = "_ks-5";
export var dropdownImage = "_ks-6";
export var editAssigneeForm = "_ks-a";
export var editButton = "_ks-3";
export var email = "_ks-7";
export var hidden = "_ks-d";
export var input = "_ks-8";
export var saveButton = "_ks-b";
export var shopifyIcon = "_ks-c";
export var suggestionBadge = "_ks-e";
export var suggestionText = "_ks-f";
export var username = "_ks-9";